import * as React from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { Formit } from '@oakwood/formit'
import { useGlobal } from 'api'
import { useTranslations } from 'containers/Translations/TranslationsContext'
import AuthLogin from './partials/AuthLogin'
import AuthLoginEmail from './partials/AuthLoginEmail'
import AuthRecoverPassword from './partials/AuthRecoverPassword'
import AuthRegister from './partials/AuthRegister'
import AuthRegisterEmail from './partials/AuthRegisterEmail'
import { useAuth } from './AuthContext'
import * as constants from './constants'

export const useStyles = makeStyles((theme) => ({
  header: {
    ...theme.mixins.verticalRhythm(2),
    marginBottom: theme.spacing(4),
    textAlign: 'center',
  },
  main: {},
  footer: {
    ...theme.mixins.verticalRhythm(0.5),
    marginTop: theme.spacing(4),
    textAlign: 'center',
  },
}))

function Auth(props) {
  const classes = useStyles(props)
  const { onFormSubmit, screen } = useAuth()
  const { loginEnabled } = useGlobal()
  const t = useTranslations()

  if (!loginEnabled) {
    return null
  }

  return (
    <Formit
      validationErrors={{
        email: t('Web.Forms.MustBeValidEmail'),
        password: t('Web.SetPassword.ValidationError'),
      }}
      initialValues={{
        email: '',
        password: '',
        rememberMe: false,
      }}
      onSubmit={onFormSubmit}
    >
      {screen === constants.SCREEN_LOGIN && <AuthLogin classes={classes} />}
      {screen === constants.SCREEN_LOGIN_EMAIL && <AuthLoginEmail classes={classes} />}
      {screen === constants.SCREEN_REGISTER && <AuthRegister classes={classes} />}
      {screen === constants.SCREEN_REGISTER_EMAIL && <AuthRegisterEmail classes={classes} />}
      {screen === constants.SCREEN_RECOVER_PASSWORD && <AuthRecoverPassword classes={classes} />}
    </Formit>
  )
}

export default Auth
